.providersSection {
}

.providersList {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  border-top: 1px solid var(--dark-8);
  padding-top: 10px;
}

.providerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  transition: border-color 0.2s ease;
  border-radius: 12px;
  height: 46px;

  &:hover {
    background-color: var(--dark-3);
  }
}

.providerInfo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.providerIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.accountCounterContainer {
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--dark-4);
  background: var(--dark-3);
  padding: 6px 8px;

  .accountCounter {
    margin-right: 4px;
    font-weight: 800;
  }
}
